// @flow

import { get } from 'lodash';
import {
  FETCH_PRE_PAYMENT_DETAILS,
  FETCH_PRE_PAYMENT_DETAILS_RESOLVED,
  FETCH_PRE_PAYMENT_DETAILS_REJECTED,
  CLEAR_PRE_PAYMENT_DETAILS,
} from 'Store/member-space/pre-payment/prePayment.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_PRE_PAYMENT_DETAILS](state: ReduxState): ReduxState {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_PRE_PAYMENT_DETAILS_RESOLVED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      data: get(action, 'payload'),
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_PRE_PAYMENT_DETAILS_REJECTED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
  [CLEAR_PRE_PAYMENT_DETAILS](): ReduxState {
    return initialState;
  },
});
